import { render } from "./TermsAndConditionsAdditional.vue?vue&type=template&id=6b1252b3&scoped=true"
const script = {}

import "./TermsAndConditionsAdditional.vue?vue&type=style&index=0&id=6b1252b3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1252b3"]])

export default __exports__